// Converts "0900" to "9:00 AM"
// Converts "1700" to "5:00 PM"
const formatTime = (time: string) => {
  const hours = parseInt(time.substring(0, 2), 10);
  const minutes = parseInt(time.substring(2, 4), 10);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleTimeString([], options);
};

export { formatTime };
